import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f86500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headert" }
const _hoisted_2 = {
  style: {"padding-bottom":"0"},
  class: "navbar navbar-1 navbar-expand-lg navbar-light py-0"
}
const _hoisted_3 = { class: "container-fluid child-div" }
const _hoisted_4 = { href: "https://em.techandover.com/" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" data-v-64f86500><span class=\"navbar-toggler-icon\" data-v-64f86500></span></button><div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\" data-v-64f86500><ul class=\"navbar-nav ms-auto mb-2 mb-lg-0\" data-v-64f86500><li class=\"nav-item\" data-v-64f86500><a class=\"nav-link nav-linkks link-a px-lg-3\" aria-current=\"page\" href=\"https://em.techandover.com/\" data-v-64f86500>HOME</a></li><li class=\"nav-item\" data-v-64f86500><a class=\"nav-link nav-linkks px-lg-3 link-b\" href=\"https://em.techandover.com/contact/\" data-v-64f86500>CONTACT US</a></li><li class=\"nav-item\" data-v-64f86500><a class=\"nav-link nav-linkks px-lg-3 link-c\" href=\"#\" data-v-64f86500>LOGIN/REGISTER</a></li></ul></div>", 2)
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  style: {"padding":"0px !important","margin-top":"0px"},
  class: "text-white"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  style: {"font-size":"36px","line-height":"1","letter-spacing":"0.04em","font-weight":"700"},
  class: "text-white text-center mt-8rem"
}, " LOGIN ", -1))
const _hoisted_10 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_11 = { class: "login-form" }
const _hoisted_12 = { class: "form-body1" }
const _hoisted_13 = { class: "form-body1 row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row form-body1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-3 form-check" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "checkbox",
      class: "form-check-input",
      id: "exampleCheck1"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "form-check-label",
      for: "exampleCheck1"
    }, [
      /*#__PURE__*/_createElementVNode("em", { style: {"color":"#7c7f85","font-weight":"600"} }, "Remember!")
    ])
  ])
], -1))
const _hoisted_21 = { class: "col-6 text-end col-block pb-5" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Forget Password?", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = ["data-kt-indicator"]
const _hoisted_25 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_26 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  style: {"font-size":"13px"},
  class: "text-center pt-3"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" DONT HAVE AN ACCOUNT? ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("SIGN UP")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-muted text-uppercase fw-bolder mb-5" }, "or", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/google-icon.svg",
  class: "h-20px me-3"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Continue with Google ")
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/linkedin.svg",
  class: "h-20px me-3"
}, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Continue with LinkedIn ")
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTLoader = _resolveComponent("KTLoader")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("img", {
              class: "nav-logoo",
              src: require('@/assets/img/emerture.png'),
              alt: "logo"
            }, null, 8, _hoisted_5)
          ]),
          _hoisted_6
        ])
      ]),
      _hoisted_8,
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loaderEnabled)
        ? (_openBlock(), _createBlock(_component_KTLoader, {
            key: 0,
            logo: _ctx.loaderLogo
          }, null, 8, ["logo"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Form, {
            class: "form w-100 border",
            id: "kt_login_signin_form",
            onSubmit: _ctx.onSubmitLogin,
            "validation-schema": _ctx.login
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    placeholder: "Email",
                    class: "d-block w-100 col-block",
                    type: "text",
                    name: "email",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ]),
                  _createVNode(_component_Field, {
                    placeholder: "Password",
                    class: "d-block w-100 col-block",
                    type: "password",
                    name: "password",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_router_link, {
                    class: "text-greenish",
                    to: "/forgot-password"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_23,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  type: "submit",
                  ref: "submitButton",
                  id: "kt_sign_in_submit",
                  style: {"background-color":"#222","border-radius":"0px"},
                  class: "btn py-3 mt-3 mb-4 text-white hover-success"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, " LOGIN "))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_29))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_24)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"]),
          _createElementVNode("p", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_router_link, {
              style: {"border-bottom":"2px solid #236DB5"},
              class: "text-greenish",
              to: "/sign-up"
            }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_33,
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.googleLogin && _ctx.googleLogin(...args))),
        class: "btn btn-flex flex-center btn-light btn-lg w-100 mb-5"
      }, _hoisted_36),
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.linkedInLogin && _ctx.linkedInLogin(...args))),
        class: "btn btn-flex flex-center btn-light btn-lg w-100 mb-5"
      }, _hoisted_39)
    ])
  ], 64))
}